import { render, staticRenderFns } from "./PCareers.vue?vue&type=template&id=5afdba66&scoped=true&"
import script from "./PCareers.vue?vue&type=script&lang=ts&"
export * from "./PCareers.vue?vue&type=script&lang=ts&"
import style0 from "./PCareers.vue?vue&type=style&index=0&id=5afdba66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afdba66",
  null
  
)

export default component.exports